import { sanitize } from "../Messages/Messages.js";
export const SingleTicketDetails = ({singleTicketDetails,formatDate,isDecisionTicket}) => {
  const groupCount = singleTicketDetails?.webCustomProperties?.length || 0;
    return (
              <div className="ticket-details-header">
                <h6 className="details-title">
                  Details for:{" "}
                  <a
                    href={sanitize(singleTicketDetails.url)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {singleTicketDetails.formattedReference}
                  </a>
                </h6>
    
                <div className="ticket-info-grid">
                  <div className="info-item">
                    <span className="info-label">Ticket Number:</span>
                    <span className="info-value">{singleTicketDetails.formattedReference}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Date Logged:</span>
                    <span className="info-value">{formatDate(singleTicketDetails.date)}</span>
                  </div>
    
                  <div className="info-item">
                    <span className="info-label">Status:</span>
                    <span className="info-value">{singleTicketDetails.eventStatusEnum}</span>
                  </div>
    
                  <div className="info-item">
                    <span className="info-label">Stage: </span>
                    <span className="info-value">{singleTicketDetails.currentStage}</span>
                  </div>
                </div>
                {!isDecisionTicket  && ( 
                  <div className="summary-section">
                    <span className="summary-label">Summary:</span>
                    <span className="summary-text" dangerouslySetInnerHTML={{__html: sanitize(singleTicketDetails.remarks),}}/>
                  </div>
                  )}
                {isDecisionTicket && (
                 <div className="summary-section">
                <span className="info-value">{singleTicketDetails.Parentticketnumber} Ticket Details :</span>
                <hr style={{ border: "1px solid #ccc", margin: "10px 0" }} /> 
                <div className="mb-3">
                    <span className="info-value">Description of request:</span>
                    <span className="summary-text"> {singleTicketDetails.Parentticketremarks}</span>
                  </div>
                <div className={`details-container ${groupCount <= 2 ? "stacked-layout" : "grid-layout"}`}>
              {singleTicketDetails?.webCustomProperties?.map((section, index) => (
                <div className="details-group" key={index}>
                  {(section.group || section.title) && (
                    <div className="details-group-title">
                      {section.group || section.title}
                    </div>
                  )}

                  {section.fields?.map((field, idx) => (
                    <div className="details-row" key={idx}>
                      <div className="details-label">{field.title}</div>
                      <div className="details-value">{field.value}</div>
                    </div>
                  ))}

                  {section.options?.map((option, idx) => (
                    <div className="details-row" key={idx}>
                      <div className="details-label checkbox-label">
                        <span className="checkbox">
                          {option.selected ? "✔" : ""}
                        </span>
                        {option.label}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}
              </div>
);
}